export default __webpack_public_path__ + "static/media/1620935127681_image0.1e39ce1b.jpeg";